import { Injectable } from '@angular/core';

// 3rd Party
import { Subject, Observable } from 'rxjs';

// cc-common imports
import { CCLocalStorageCategory, CCLocalStorageService, Utils } from 'cc-common';

// service imports
import { AuthService } from '../auth.service';
import { ContextManagerService } from '../data-services/context-manager.service';

// model imports
import { BookmarkInfo } from '../../_models/bookmark-info';

// constant imports
import { StorageKeyConstants } from '../../_constants/storage-key-constants';

@Injectable({
    providedIn: 'root'
})
export class BookmarkService {
    private readonly _subjectBookmark: Subject<BookmarkInfo[]> = new Subject();
    private _savedBookmarks: BookmarkInfo[] = [];

    constructor(
        private readonly authService: AuthService,
        private readonly contextService: ContextManagerService,
        private readonly localStorageService: CCLocalStorageService
    ) {
        this.authService.getSubjectLoginSuccess().subscribe(() => {
            this.getSavedBookmarkItems();
            this.updateBookmarkSaveNotify();
        });
        this.contextService.getContext().subscribe(() => {
            this.getSavedBookmarkItems();
            this.updateBookmarkSaveNotify();
        });
    }

    getBookmarkSaveNotify(): Observable<BookmarkInfo[]> {
        return this._subjectBookmark;
    }

    updateBookmarkSaveNotify(): void {
        this._subjectBookmark.next(this._savedBookmarks);
    }

    saveBookmarkItems(itemsToStore: BookmarkInfo[]): void {
        itemsToStore = Utils.uniqueList(itemsToStore, 'name');
        this._savedBookmarks = [];
        if (itemsToStore.length > 0) {
            this.localStorageService.setItem(
                StorageKeyConstants.bookmarks,
                JSON.stringify(itemsToStore),
                CCLocalStorageCategory.FAV
            );
        } else {
            this.localStorageService.removeItem(StorageKeyConstants.bookmarks, CCLocalStorageCategory.FAV);
        }
        this.getSavedBookmarkItems();
        this.updateBookmarkSaveNotify();
    }

    getSavedBookmarkItems(): BookmarkInfo[] {
        const savedBookmarks = JSON.parse(
            this.localStorageService.getItem(StorageKeyConstants.bookmarks, CCLocalStorageCategory.FAV)
        );
        if (savedBookmarks && savedBookmarks.length > 0) {
            this._savedBookmarks = Utils.uniqueList(savedBookmarks, 'name');
        } else {
            this._savedBookmarks = [];
        }

        return this._savedBookmarks;
    }
}
